import { DropdownStyles } from './styles/Dropdown.styles';
import { SearchBoxStyles } from './styles/SearchBox.styles';
import { TextFieldStyles } from './styles/TextField.styles';
import { BreadcrumbStyles } from './styles/Breadcrumb.styles';
import { IconButtonStyles } from './styles/IconButton.styles';
export var CoherenceStyles = {
    Dropdown: {
        styles: DropdownStyles
    },
    SearchBox: {
        styles: SearchBoxStyles
    },
    TextField: {
        styles: TextFieldStyles
    },
    Breadcrumb: {
        styles: BreadcrumbStyles
    },
    IconButton: {
        styles: IconButtonStyles
    }
};
//# sourceMappingURL=CoherenceStyles.js.map